export const checkPeriodName = 'checkPeriod';

export const checkPeriodFirstMonthName = 'checkPeriodFirstMonth';

export const checkPeriodFromName = 'checkPeriodFrom';

export const checkPeriodTillName = 'checkPeriodTill';
